module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"module","commonjs":"module","commonjs2":"module","root":"undefined"}
// module id = 42
// module chunks = 0